
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/editorials/anna-copenhagen",
      function () {
        return require("private-next-pages/editorials/anna-copenhagen.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/editorials/anna-copenhagen"])
      });
    }
  